import React from 'react'
// eslint-disable-next-line
import styles from './Spinner.scss'
const Spinner = () => {
  return (
    <div className='d-flex flex-column justify-content-center align-items-center'>
      <p className='mb-1 text-center texto-cargando' style={{fontSize: '1.5rem'}}>Cargando</p>
      <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    </div>
  )
}

export default Spinner